import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [55.640945, -5.239905, 53.6],
  [55.641042, -5.239864, 53.8],
  [55.641144, -5.23983, 53.8],
  [55.641246, -5.239792, 53.8],
  [55.641348, -5.239748, 53.6],
  [55.641444, -5.239703, 53.6],
  [55.641546, -5.239656, 53.6],
  [55.641648, -5.23961, 53.6],
  [55.64175, -5.239566, 53.8],
  [55.641852, -5.239537, 53.8],
  [55.641954, -5.239522, 53.8],
  [55.642056, -5.239511, 53.8],
  [55.642163, -5.239508, 53.8],
  [55.642265, -5.239515, 53.8],
  [55.642367, -5.239521, 53.8],
  [55.642474, -5.239523, 53.8],
  [55.642582, -5.239522, 53.8],
];

export default stream;
